export const rem = (...args: number[]): string => {
	let documentFontSize = 16;

	try {
		documentFontSize = Number(getComputedStyle(document.documentElement).fontSize.replace('px', ''));
		if (args.constructor !== Array) {
			return `${args[0] / documentFontSize}rem`;
		} else if (args.constructor === Array) {
			return args.reduce((prev, curr) => `${prev} ${curr / documentFontSize}rem`, '');
		}
	} catch (e) {
		return args.reduce((prev, curr) => `${prev} ${curr}rem`, '');
	}
	return args.reduce((prev, curr) => `${prev} ${curr}rem`, '');
};
